export default __webpack_public_path__ + "static/blob2-d3ff678a8ba9d54e0518e437662593e6.svg";